const stateKeys = {
  dismissPvOptimisation: 'dismissPvOptimisation'
}

export const state = () => ({
  dismissPvOptimisation: false,
  hasPvOptimisation: false,
  optimisationDetails: null
})

export const mutations = {
  setDismissPvOptimisation(state, data) {
    state.dismissPvOptimisation = data
  },
  setSettings(state, data) {
    state.optimisationDetails = data
  },
  setSettingsValue(state, { key, value }) {
    if (state.optimisationDetails) {
      state.optimisationDetails[key] = value
    }
  },
  setHasPvOptimisation(state, value) {
    state.hasPvOptimisation = value
  }
}

export const actions = {
  clearStorage({ dispatch }) {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    dispatch('clearSettings')
  },
  clearSettings({ commit }) {
    commit('setSettings', null)
    commit('setHasPvOptimisation', false)
  },
  getDismissPvOptimisation() {
    return this.$storage.getUniversal(stateKeys.dismissPvOptimisation)
  },
  setDismissPvOptimisation({ commit }, value) {
    commit('setDismissPvOptimisation', value)
    this.$storage.setUniversal(stateKeys.dismissPvOptimisation, value)
  },
  async getOptimisationDetails({ commit }) {
    const data = await this.$apiAaltra.settingsPvOptimisation()

    if (!data) return
    const hasPvOptimisation = !!(data && data.gatewayId && data.houseId)

    commit('setHasPvOptimisation', hasPvOptimisation)

    data.maxAllowedTemp = data.maxAllowedTemp || 22
    data.emitterType = data.emitterType || 'Unknown'

    commit('setSettings', data)

    return data
  },
  async saveData(_, { data }) {
    const relevantData = {
      enabledDate: this.$dateTimeToEpoch(new Date()) * 1000
    }
    if (data.authenticationCode) {
      relevantData.authenticationCode = data.authenticationCode
    }
    if (data.hasPermissionDHW) {
      relevantData.hasPermissionDHW = data.hasPermissionDHW
    }
    if (data.hasPermissionSH) {
      relevantData.hasPermissionSH = data.hasPermissionSH
      relevantData.maxAllowedTemp = data.maxAllowedTemp
      relevantData.emitterType = data.emitterType
    }
    await this.$apiAaltra.updateSettingsPvOptimisation(relevantData)
  },
  async deactivatePvOptimisation({ dispatch }) {
    await dispatch('clearStorage')
    await this.$apiAaltra.deleteOnectaToken()
  }
}
